import Thumb from './thumb';

export default class ThumbSimpleText extends Thumb {
  constructor (parameters) {
    super();

    this.text = '';
    this.setValues(parameters);
  }

  getA () {
    return '<a id="' + this.uuid + '" class="item"  data-id="' + this.id + '" style="background-color: transparent !important;"></a>';
  }

  getItem () {
    const pxHeight = this.height + 'px';
    const $container = this.getItemContainer();
    const $text = $('<div class="text"><span>' + this.text.trimToLength(50) + '</span></div>');

    $text.css('height', pxHeight).css('line-height', pxHeight);
    $container.find('a').append($text);

    return $container;
  }
}
